module.exports = __webpack_public_path__ + "img/palmas-room-2.d18a2b4b.jpg";